"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const preloaderSlice_1 = require("../../redux/slices/preloaderSlice");
require("./app.scss");
const core_1 = require("@material-ui/core");
class App extends react_1.Component {
    componentDidMount() {
        this.props.showLoader();
        setTimeout(() => this.props.hideLoader(), 500);
    }
    render() {
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("h3", { className: 'page-title' }, "Directory"),
            react_1.default.createElement(core_1.Box, { id: 'directory-wrapper' },
                react_1.default.createElement("div", { className: "heading" },
                    react_1.default.createElement("h4", null, "Find Expert Witnesses & Litigation Support Professionals within minutes"),
                    react_1.default.createElement("p", null, "Connect with 10,000+ Expert Witnesses & Litigation Support Specialists nationwide.")),
                react_1.default.createElement(core_1.Box, { display: 'flex', className: 'wrapper' },
                    react_1.default.createElement("a", { href: "#/directory/experts", className: 'card' },
                        react_1.default.createElement("div", { className: "card-icon icon-expert" }),
                        react_1.default.createElement("div", { className: "card-content" },
                            react_1.default.createElement("h4", null, "Expert Witnesses"),
                            react_1.default.createElement("p", null, "Find the right expert witness for your case. Search for an expert witness by area of expertise and find the support you need faster than you ever did."))),
                    react_1.default.createElement("a", { href: "#/directory/services", className: 'card' },
                        react_1.default.createElement("div", { className: "card-icon icon-service" }),
                        react_1.default.createElement("div", { className: "card-content" },
                            react_1.default.createElement("h4", null, "Litigation Support Services"),
                            react_1.default.createElement("p", null, "Find court reporters, interpreters and other litigation support professionals within minutes to help you with your complex and large-scale litigation.")))))));
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        showLoader: () => dispatch(preloaderSlice_1.showLoader()),
        hideLoader: () => dispatch(preloaderSlice_1.hideLoader())
    };
};
exports.default = react_redux_1.connect(null, mapDispatchToProps)(App);
